// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__2FHpV","large":"styles_large__sfqFo"};